// app state ผูกกับ URL query → deep-linkable / reload คืนสภาพเดิม
import type { Level } from "../api/client";

export interface AppState {
  indicator: string | null;
  level: Level;
  area: string | null; // area_code ที่ drill อยู่ (null = ทั้งประเทศ)
  period: number | null; // ปี พ.ศ.
  classify: string;
}

type Listener = (s: AppState) => void;

const DEFAULT: AppState = {
  indicator: null,
  level: "province",
  area: null,
  period: null,
  classify: "quantile",
};

function fromURL(): AppState {
  const p = new URLSearchParams(location.search);
  return {
    indicator: p.get("indicator"),
    level: (p.get("level") as Level) || DEFAULT.level,
    area: p.get("area"),
    period: p.get("period") ? Number(p.get("period")) : null,
    classify: p.get("classify") || DEFAULT.classify,
  };
}

function toURL(s: AppState) {
  const p = new URLSearchParams();
  if (s.indicator) p.set("indicator", s.indicator);
  if (s.level) p.set("level", s.level);
  if (s.area) p.set("area", s.area);
  if (s.period) p.set("period", String(s.period));
  if (s.classify && s.classify !== DEFAULT.classify) p.set("classify", s.classify);
  const qs = p.toString();
  history.replaceState(null, "", qs ? `?${qs}` : location.pathname);
}

class Store {
  private state: AppState = fromURL();
  private listeners = new Set<Listener>();

  get(): AppState {
    return this.state;
  }

  set(patch: Partial<AppState>) {
    this.state = { ...this.state, ...patch };
    toURL(this.state);
    this.emit();
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  private emit() {
    for (const fn of this.listeners) fn(this.state);
  }
}

export const store = new Store();

// sync กับปุ่ม back/forward
window.addEventListener("popstate", () => store.set({}));
